import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import '../css/trimmis.scss';
import stars from '../img/stars.svg';
import InfoButton from './InfoButton.js';

class InfoCardBlue extends Component {

  render() {
    const styles = {
      marginBottom: "20px"
    }
    return (
        <div className="trimmis-info-card">
          <h2 className="content-margin-20 trimmis-info-card-title">{this.props.title}</h2>
          <div className="content-margin-20 trimmis-info-card-stars"><img src={stars} alt="stars"/></div>
          <div className="content-margin-20 trimmis-info-card-description">{this.props.description}</div>
          <div className="content-margin-20 trimmis-info-card-description-owner">{this.props.descriptionOwner}</div>
          <div className="col-sm-8 col-sm-offset-2" style={styles}>
            <InfoButton link="#" text="Näytä lisää"/>
          </div>
            <div className="clearfix"></div>
        </div>
    );
  }
}

export default InfoCardBlue;


// WEBPACK FOOTER //
// ../components/InfoCardBlue.js